exports.components = {
  "component---src-pages-legal-aviso-legal-js": () => import("./../../../src/pages/legal/aviso-legal.js" /* webpackChunkName: "component---src-pages-legal-aviso-legal-js" */),
  "component---src-pages-legal-cookies-js": () => import("./../../../src/pages/legal/cookies.js" /* webpackChunkName: "component---src-pages-legal-cookies-js" */),
  "component---src-pages-legal-privacidad-js": () => import("./../../../src/pages/legal/privacidad.js" /* webpackChunkName: "component---src-pages-legal-privacidad-js" */),
  "component---src-templates-page-template-js": () => import("./../../../src/templates/page-template.js" /* webpackChunkName: "component---src-templates-page-template-js" */)
}

